import { useCallback, useMemo, useState } from 'react';
import * as UI from './styles';
import Button from '../Button';
import downloadIcon from '../../assets/icons/download.svg';
import FileSaver from 'file-saver';
import { usePDFViewer } from '../../contexts/pdfViewer';
import { Page, Document, pdfjs } from 'react-pdf';
import Divider from '../Divider';
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export interface PDFViewerProps {
  showButtonDownload?: boolean,
  configButton?: { value: string, icon: JSX.Element, onClick: React.MouseEventHandler<HTMLButtonElement> }
}

function PDFViewer({ showButtonDownload, configButton }: PDFViewerProps) {
  const { file } = usePDFViewer();
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }

  const handleDownloadExam = useCallback(() => {
    if (file) {
      FileSaver.saveAs(file.url, file.name);
    }
  }, [file]);

  const buttonDownload = useMemo(() => {
    if (showButtonDownload && file) {
      return <Button
        value={"Download Arquivo"}
        icon={<img src={downloadIcon} alt="Download Arquivo" />}
        onClick={() => handleDownloadExam()} />
    }
  }, [file, handleDownloadExam, showButtonDownload]);

  const customButton = useMemo(() => {
    if (configButton) {
      return <Button
        value={configButton.value}
        icon={configButton.icon}
        onClick={configButton.onClick} />
    }
  }, [configButton]);


  return (
    <UI.Container>
      <UI.ListHeader>
        <span>{file?.name ?? 'Sem Prova'}</span>
        {file?.name && <Divider w='100%' h={0}/>}
      </UI.ListHeader>

      <UI.PDF id='container-pdf'>
        {!!file && <Document
          file={{ url: file.url }}
          loading="Loading..."
          renderMode='svg'
          onLoadError={error => console.log(error)}
          onSourceError={error => console.log(error)}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {Array.from(
            new Array(numPages),
            (el, index) => (
              <Page
                width={(document.getElementById('container-pdf')?.offsetWidth ?? 500) - 20}
                key={`page_${index + 1}`}
                pageNumber={index + 1}
              />
            ),
          )}
        </Document>
        }
      </UI.PDF>

      {(!!configButton || !!showButtonDownload) && <UI.ButtonBox>
        {customButton}
        {buttonDownload}
      </UI.ButtonBox>}
    </UI.Container>
  );
}

export default PDFViewer;
